import {isNotNil} from 'ramda';

import {DEFAULT_SETTINGS} from '../constants/defaultSettings';
import {selectGridSettings} from '../store/createEagGridStore';
import {useEagGridStore} from '../store/useEagGridStore';
import type {UsePresetStateReturn} from '../types/UsePresetStateReturn';
import {getPresetStates} from '../utils/getPresetStates';
import {isPresetCustom} from '../utils/isPresetCustom';
import {usePresetActivation} from './usePresetActivation';
import {usePresetCrud} from './usePresetCrud';
import {usePresetList} from './usePresetList';

export const usePresetState = (): UsePresetStateReturn => {
  const store = useEagGridStore();
  const {refreshPresets: _refreshPresets, ...listMembers} = usePresetList();
  const activation = usePresetActivation();
  const crud = usePresetCrud();

  const applyPresetToVirtual = async (presetId: string, saveCurrentPreset = false) => {
    if (saveCurrentPreset) {
      const state = store.getState();
      if (isNotNil(state.activePreset) && isPresetCustom(state.activePreset)) {
        await crud.updatePreset(
          state.activePreset.id,
          getPresetStates(state.columnStates),
          selectGridSettings(state) ?? DEFAULT_SETTINGS
        );
      }
    }

    await activation.applyPresetToVirtual(presetId);
  };

  return {
    ...listMembers,
    ...activation,
    applyPresetToVirtual,
    ...crud,
  };
};
